<template>
    <div class="documentation">
        <div class="row">
            <div class="col-md-5">
                <Breadcumb title="Détails utilisateurs" :breadcumb-data="breadcumbData"></Breadcumb>
            </div>
        </div>
        <div class="row cardcontainer" v-if="currentUser">
            <div class="col-xl-4">
                <b-card no-body class="mb-4">
                    <b-card-body>
                        <div class="media">
                            <div class="media-body pt-2 ml-3">
                                <h5 class="mb-2">{{ currentUser.userprofile.lastname }} {{ currentUser.userprofile.firstname }}</h5>
                                <div class="text-muted small"><template v-if="$cookie.get('language') == 'fr'">{{ currentUser.userprofile.user_type.label }}</template>
                                    <template v-if="$cookie.get('language') == 'en'">{{ currentUser.userprofile.user_type.label_en }}</template></div>
                            </div>
                        </div>
                    </b-card-body>
                    <hr class="border-light m-0">
                    <b-card-body>
                        <div class="mb-2">
                            <span class="text-muted">Email:</span>&nbsp;
                            {{ currentUser.email }}
                        </div>
                        <div class="mb-2">
                            <span class="text-muted">Périmètre :</span>&nbsp;
                            <ul>
                                <li v-for="company in currentUser.userprofile.related_companies">{{ company.name }}</li>
                            </ul>
                        </div>
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-xl-8">
                <b-card no-body class="mb-4">
                    <b-card-header>
                        Gestion des tags
                    </b-card-header>
                    <b-card-body>
                        <multiselect
                            v-model="tags"
                            :options="tagData"
                            :multiple="true"
                            :close-on-select="false"
                            label="label"
                            track-by="id"
                            placeholder="Assignation Utilisateur - Tags"
                            style="z-index:140"
                            @input="updateUserTag"
                        />
                    </b-card-body>
                </b-card>
            </div>
            <div class="col-xl-12">
                <b-card no-body class="">
                    <b-card-header>
                        Gestion des tags
                    </b-card-header>
                    <b-card-body>
                        <b-form @submit="updateUserCompanies">
                            <b-form-group :label="$t('companies')" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
                                <v-jstree
                                        :data="treeData"
                                        :class="{ 'tree-rtl': isRTL }"
                                        show-checkbox
                                        multiple
                                        allow-batch
                                        whole-row
                                        draggable/>
                            </b-form-group>
                            <b-form-row>
                                <div class="col-md-10 ml-md-auto">
                                    <b-btn type="submit" variant="primary">Modifier le périmètre</b-btn>
                                </div>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
    import Breadcumb from '../../components/breadcumb';
    import { mapState } from 'vuex';
    import {USER_REQUEST} from "../../_store/user/actiontypes";
    import Multiselect from 'vue-multiselect'
    import VJstree from 'vue-jstree'
    import {ADMIN_RESULTTAGS_REQUEST} from "../../_store/administration/result/actiontypes";
    import {
        ADMIN_USER_DETAIL_REQUEST, ADMIN_USER_UPDATE_COMPANIES_REQUEST,
        ADMIN_USER_UPDATE_TAGS_REQUEST
    } from "../../_store/administration/user/actiontypes";
    import {GET_HIERARCHICAL_COMPANIES_REQUEST} from "../../_store/company/actiontypes";

    function getChildrens(company, companies) {
        return company.companies.map(children => {
            let selected = false;
            if (companies && companies !== []){
                selected = companies.find(comp => comp.id === children.id);
            }
            if (children.companies.length > 0){
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': selected,
                    'children': getChildrens(children, companies),
                    'opened': false,
                }
            }
            else {
                return {
                    'show-checkbox': false,
                    'text': children.name,
                    'id': children.id,
                    'selected': selected,
                    'children': [],
                    'opened': false,
                }
            }
        })
    }

    export default {
        name: 'adminCategoryAdd',
        components: {Breadcumb, Multiselect, VJstree},
        mounted() {
            this.$store.dispatch(ADMIN_USER_DETAIL_REQUEST, { id : this.$route.params.id})
                .then(result => {
                    this.currentUser = result.data.user;
                    if (this.tags.length === 0){
                        this.tags = result.data.user.userprofile.tags.map(tag => {
                            return {
                                id: tag.id,
                                label: tag.label
                            }
                        })
                    }
                    this.$store.dispatch(GET_HIERARCHICAL_COMPANIES_REQUEST)
                        .then(response => {
                            this.treeData = response.data.hierarchical_companies.map(company => {
                                let childrens = [];
                                if (company.companies.length > 0) {
                                    childrens = getChildrens(company, this.currentUser.userprofile.related_companies)
                                }
                                let selected = false;
                                if (this.currentUser.userprofile.related_companies && this.currentUser.userprofile.related_companies !== []){
                                    selected = this.currentUser.userprofile.related_companies.find(comp => comp.id === company.id);
                                }

                                return {
                                    'show-checkbox': false,
                                    'text': company.name,
                                    'id': company.id,
                                    'children': childrens,
                                    'opened': false,
                                    'selected': selected
                                }
                            });
                            console.log(this.treeData);
                        });
                })
            this.$store.dispatch(ADMIN_RESULTTAGS_REQUEST, {full: 1})
                .then(result => {
                    this.tagData = result.data.tags.map(tag => {
                        console.log(tag.label);
                        return {
                            id: tag.id,
                            label: tag.label
                        }
                    });
                })
        },
        computed: mapState({
            errors: state => state.admin_user.errors,
            user: state => state.user.user
        }),
        data() {
            return ({
                breadcumbData: [
                    { text: 'Accueil', href: '/dashboard/' },
                    { text: 'Liste des utilisateurs', href: '/dashboard/administration/userlist/'},
                    { text: 'Details Utilisateur', active: true},

                ],
                tagData: [{
                    language: 'Tags Utilisateur',
                    libs: []
                }],
                tags: [],
                treeData: [],
                currentUser: false,
                companies: [],
            });
        },
        layout(context) {
            return 'layout';
        },
        methods: {
            updateUserCompanies: function(e){
                e.preventDefault();
                this.$store.dispatch(ADMIN_USER_UPDATE_COMPANIES_REQUEST, {
                    companies: this.treeData,
                    userId: this.currentUser.id
                })
            },
            updateUserTag: function(){
                console.log("I am triggered");
                console.log(this.tags);
                this.$store.dispatch(ADMIN_USER_UPDATE_TAGS_REQUEST, {
                    tags: this.tags.map(tag => { return tag.id }),
                    userId: this.currentUser.id
                })
            }
        }
    };
</script>
